import { IEvent } from '.';

export const eventsSelector: (state: any) => IEvent[] = state => state.events;
